var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEuropeanWindowsIcon3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7003_711)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7003_711",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 36,
    height: 36
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 0H0V36H36V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7003_711)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.57625 29.8039C5.01125 30.4339 5.56625 30.9889 6.19625 31.4239C7.62125 32.4589 9.48125 32.9989 11.7162 32.9989H24.2862C29.4462 32.9989 32.6412 30.0889 32.9562 25.1689H3.03125C3.15125 27.0139 3.67625 28.5739 4.57625 29.8039Z",
    fill: "#FECB00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.425 6.195C30.99 5.565 30.435 5.01 29.805 4.575C28.38 3.54 26.52 3 24.285 3H11.715C6.255 3 3 6.255 3 11.715V22.92H33V11.715C33 9.48 32.46 7.62 31.425 6.195ZM22.635 14.34L18.795 18.18C18.36 18.615 17.64 18.615 17.205 18.18L13.365 14.34C13.14 14.115 13.035 13.83 13.035 13.545C13.035 13.26 13.14 12.96 13.365 12.75C13.8 12.3 14.52 12.3 14.955 12.75L18 15.78L21.045 12.735C21.48 12.3 22.2 12.3 22.635 12.735C23.07 13.17 23.07 13.89 22.635 14.34Z",
    fill: "#FECB00"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7003_711"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEuropeanWindowsIcon3);
export default __webpack_public_path__ + "static/media/EuropeanWindowsIcon3.f2baa9e911487feab2b801b2a75e82b7.svg";
export { ForwardRef as ReactComponent };